module.exports = __webpack_public_path__ + "static/media/shipping-fast.a8bcb113.svg";